import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import error from "./assets/images/404.png";

const root = ReactDOM.createRoot(document.getElementById("root"));

class ErrorBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.log({ error, errorInfo });
    // errorService.log({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            color: "white",
          }}
        >
          <img style={{ width: "150px", height: "auto" }} src={error} />
          <h1 style={{ fontSiez: "36px" }}>Upss,</h1>
          <h2
            style={{
              borderRadius: "15px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              rowGap: "40px",
            }}
          >
            Wystąpił bład, skonktaktuj się z działem IT
          </h2>

          <a
            onClick={() => (window.location.href = "/")}
            style={{
              marginTop: "1rem",
              backgroundColor: "white",
              color: "black",
              padding: ".5rem 1rem",
              fontSize: "1.1rem",
              fontWeight: "500",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Strona główna
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

root.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
);
reportWebVitals();
